<template>
  <adivare-input
    @validation-request="validateField"
    :outer-class="outerClass"
    :input-class="inputClass"
    :autocomplete="autocomplete"
    :legend-class="legendClass"
    :show-property="true"
    :label-class="labelClass"
    :property-name="propertyName"
    :placeholder="fieldLabel"
    formType="text"
    :field-label="fieldLabel"
    :optional="optional"
    :custom-error-message="errorMessage"
  />
</template>

<script>
import formMixin from "../../../mixins/form-mixin";

export default {
  name: "adivare-postcode-form-element",
  mixins: [
    formMixin,
  ],
  computed: {
    errorMessage() {
      if (false === this.$store.getters.getFormFieldValidityState(this.propertyName)) {
        return this.$t('messages_nl.label.cancellation.userLetter.postcode.error');
      }

      return '';
    },
  },
  methods: {
    validateField(value) {
      this.$store.commit('updateFormFieldValidity', {
        name: this.propertyName,
        valid: this.validatePostcode(value)
      });
    },
    validatePostcode(postcode) {
      // dutch postcode: 0000AA-9999ZZ
      if (true === /^\d{4} ?[a-zA-Z]{2}$/.test(postcode)) return true;

      // german postcode: 01000-99999
      if (true === /^\d{5}$/.test(postcode) && parseInt(postcode, 10) >= 1000 && parseInt(postcode, 10) <= 99999) return true;

      // belgian postcode: 1000-9999
      if (true === /^[1-9]{1}[0-9]{3}$/.test(postcode)) return true;

      return false;
    }
  },
}
</script>
